import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { font } from '../../utils/fontHelper';

interface EmptyStateProps {
  message: string;
  sx?: object;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, sx = {} }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        bgcolor: isDark ? '#2C2C2E' : '#F2F2F7',
        borderRadius: 2,
        p: 3,
        textAlign: 'center',
        ...sx,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: isDark ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
          fontFamily: font(),
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyState;
